import {useEffect} from "react";
import {useComputedColorScheme, useMantineTheme} from "@mantine/core";

export function useDocumentStyleEffect() {
    const mantineTheme = useMantineTheme();
    const colorScheme = useComputedColorScheme("dark", {
        getInitialValueInEffect: true,
    });

    useEffect(() => {
        if (typeof mantineTheme.primaryShade === "number") {
            document.body.style.backgroundColor = mantineTheme.colors.background[mantineTheme.primaryShade];
        } else {
            if (colorScheme === "light") {
                document.body.style.backgroundColor = mantineTheme.colors.background[mantineTheme.primaryShade.light];
            } else {
                document.body.style.backgroundColor = mantineTheme.colors.dark[mantineTheme.primaryShade.dark];
            }
        }
    }, [colorScheme]);
}